import { render, staticRenderFns } from "./TemplateGreedNew.vue?vue&type=template&id=210ca982&scoped=true&"
import script from "./TemplateGreedNew.vue?vue&type=script&lang=js&"
export * from "./TemplateGreedNew.vue?vue&type=script&lang=js&"
import style0 from "./TemplateGreedNew.vue?vue&type=style&index=0&id=210ca982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210ca982",
  null
  
)

export default component.exports